var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.75C6.7595 20.75 5.75 19.7405 5.75 18.5V5.5C5.75 4.2595 6.7595 3.25 8 3.25H14.2525L18.25 7.2185V18.5C18.25 19.7405 17.2405 20.75 16 20.75H8Z",
    fill: "#DCDDE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1495 3.5L18 7.3225V18.5C18 19.603 17.103 20.5 16 20.5H8C6.897 20.5 6 19.603 6 18.5V5.5C6 4.397 6.897 3.5 8 3.5H14.1495ZM14.3555 3H8C6.6195 3 5.5 4.1195 5.5 5.5V18.5C5.5 19.8805 6.6195 21 8 21H16C17.3805 21 18.5 19.8805 18.5 18.5V7.1145L14.3555 3Z",
    fill: "#CBCCCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8585 7.1145H18.5L14.3555 3V5.6225C14.3555 6.4465 15.0285 7.1145 15.8585 7.1145Z",
    fill: "#AEAFB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H8C7.724 18 7.5 17.7765 7.5 17.5C7.5 17.2235 7.724 17 8 17H16C16.2765 17 16.5 17.2235 16.5 17.5C16.5 17.7765 16.2765 18 16 18Z",
    fill: "#AEAFB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5H8C7.724 15.5 7.5 15.2765 7.5 15C7.5 14.7235 7.724 14.5 8 14.5H16C16.2765 14.5 16.5 14.7235 16.5 15C16.5 15.2765 16.2765 15.5 16 15.5Z",
    fill: "#AEAFB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H8C7.724 13 7.5 12.7765 7.5 12.5C7.5 12.2235 7.724 12 8 12H16C16.2765 12 16.5 12.2235 16.5 12.5C16.5 12.7765 16.2765 13 16 13Z",
    fill: "#AEAFB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5H8.04651C7.77051 10.5 7.54651 10.276 7.54651 10C7.54651 9.724 7.77051 9.5 8.04651 9.5H16C16.2765 9.5 16.5 9.724 16.5 10C16.5 10.276 16.2765 10.5 16 10.5Z",
    fill: "#196EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument1);
export default __webpack_public_path__ + "static/media/document1.8b9c54063061f3fb841c87a1b10d3301.svg";
export { ForwardRef as ReactComponent };